import {
    Navigate,
    RouteObject
} from 'react-router-dom';
import {PublicHomePage} from './features/home/pages/PublicHomePage';
import {SignOutPage} from './features/home/pages/SignOutPage';

import {IndexPage as DashboardPage} from "./features/dashboard/pages/IndexPage";
import {AppLayout} from "./layout/AppLayout";
import {RequireAuth} from "./utils/RequireAuth.tsx";

import {ProductsLayout} from "./features/products/layout.tsx";
import {OffersLayout} from "./features/offers/layout.tsx";
import {RegistrationsLayout} from "./features/registrations/layout.tsx";
import {MeteringRecordsLayout} from "./features/metering-records/layout.tsx";

// FNP-1858: the route table lives on its own so a test can mount it in a
// memory router, exactly as App.tsx mounts it in the browser router.
export const routes: RouteObject[] = [{
    path: '/',
    element: <AppLayout/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        path: 'dashboard',
        element: <RequireAuth><DashboardPage/></RequireAuth>
    }, {
        path: 'products/*',
        element: <ProductsLayout/>
    }, {
        path: 'registrations/*',
        element: <RegistrationsLayout/>
    }, {
        // FNP-1858: notification subscriptions are product-scoped and live on a
        // product's edit page. Without a product id the module throws, so the
        // bare top-level path sends the operator to the products list.
        path: 'notification-subscriptions/*',
        element: <Navigate to='/products' replace/>
    }, {
        path: 'metering-records/*',
        element: <MeteringRecordsLayout/>
    }, {
        path: 'offers/*',
        element: <OffersLayout/>
    }]
}];
